"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HostService = exports.DefaultHostService = void 0;
var _uuid = require("uuid");
var _constants = require("../utils/constants");
var _logger = require("./logger");
class DefaultHostService {
  constructor() {
    let appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.marketingId = void 0;
    this.getMarketingId = this.getMarketingId.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.marketingId = this.getMarketingId(appId);
  }
  getMarketingId() {
    let appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const localStorageMarketingId = localStorage.getItem(_constants.MARKETING_ID);
    if (localStorageMarketingId) {
      return encodeURIComponent(localStorageMarketingId);
    }
    const {
      search
    } = window.location;
    const query = new URLSearchParams(search);
    const queryMarketingId = query.get(_constants.MARKETING_ID);
    if (queryMarketingId) {
      return encodeURIComponent(queryMarketingId);
    }
    const staticMarketingId = (0, _uuid.v4)();
    return `${staticMarketingId}_${appId}`;
  }
  setMarketingId(marketingId) {
    _logger.Logger.info({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES]
    })('Storing marketing id in local storage', marketingId);
    localStorage.setItem(_constants.MARKETING_ID, marketingId);
  }
  addToCart(_ref) {
    let {
      handsetProductId,
      planProductId,
      upsoldProductIds,
      broadbandProductId,
      businessSolutionId
    } = _ref;
    (upsoldProductIds === null || upsoldProductIds === void 0 ? void 0 : upsoldProductIds.length) > 0 ? _logger.Logger.info({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES]
    })(`Handset product id ${handsetProductId}, plan product id ${planProductId}, upsold products id(s) ${upsoldProductIds}, broadband product id ${broadbandProductId}`) : _logger.Logger.info({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES]
    })(`Handset product id ${handsetProductId}, plan product id ${planProductId}, broadband product id ${broadbandProductId}, business-solution id ${businessSolutionId} `);
  }
}
exports.DefaultHostService = DefaultHostService;
class HostService extends DefaultHostService {
  constructor(_ref2) {
    var _this$config, _this$config$settings, _this$config$settings2;
    let {
      hostMarketingId,
      hostAddToCartCallback,
      config = {},
      openGuidedSellingModal
    } = _ref2;
    super(config.appId);
    this.hostMarketingId = void 0;
    this.hostAddToCartCallback = void 0;
    this.config = void 0;
    this.openGuidedSellingModal = void 0;
    this.hostMarketingId = hostMarketingId;
    this.hostAddToCartCallback = hostAddToCartCallback;
    this.config = config;
    if ((_this$config = this.config) !== null && _this$config !== void 0 && (_this$config$settings = _this$config.settings) !== null && _this$config$settings !== void 0 && (_this$config$settings2 = _this$config$settings.windowAPI) !== null && _this$config$settings2 !== void 0 && _this$config$settings2.enabled) {
      var _windowVariable$guide;
      const windowVariable = window;
      windowVariable.guidedSelling = (_windowVariable$guide = windowVariable.guidedSelling) !== null && _windowVariable$guide !== void 0 ? _windowVariable$guide : {};
      windowVariable.guidedSelling[config.appId || 'entryPoint'] = {
        launchGS: openGuidedSellingModal
      };
    }
  }
  getMarketingId() {
    if (!this.hostMarketingId) {
      return super.getMarketingId();
    }
    return this.hostMarketingId;
  }
  addToCart(_ref3) {
    let {
      handsetProductId,
      planProductId,
      upsoldProductIds,
      broadbandProductId,
      businessSolutionId,
      businessSolutionUrl
    } = _ref3;
    if (!this.hostAddToCartCallback) {
      return super.addToCart({
        handsetProductId,
        planProductId,
        upsoldProductIds,
        broadbandProductId,
        businessSolutionId,
        businessSolutionUrl
      });
    }
    return this.hostAddToCartCallback({
      handsetProductId,
      planProductId
    });
  }
  redirect(_ref4) {
    let {
      path,
      origin = window.location.origin,
      target = '_self'
    } = _ref4;
    window.open(`${origin}${path}`, target);
  }
}
exports.HostService = HostService;